import {Injectable} from '@angular/core';
import {KundeEntitiesEffects} from './kunde-entities.effects';
import {KontaktActions} from '../actions/kontakt.actions';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {KontaktSelectors} from '../selectors/kontakt.selectors';
import {filter, map, withLatestFrom} from 'rxjs';
import {KONTAKT_PAGE_SIZE} from '../reducers/kontakt.reducers';


@Injectable()
export class KontaktEffects {

  constructor(
    private kundeEntitiesEffects: KundeEntitiesEffects,
    private actions$: Actions,
    private store: Store<AppState>,
  ) {
  }

  readonly readKunden$ = this.kundeEntitiesEffects.readKunden$(
    KontaktActions.readKunden,
    KontaktActions.setDisplayedIds,
    KontaktActions.clearDisplayedKunden,
  );

  readonly readMoreKunden$ = this.kundeEntitiesEffects.readKunden$(
    KontaktActions.readMoreKunden,
    KontaktActions.addDisplayedIds,
    KontaktActions.clearDisplayedKunden,
  );

  /**
   * Die API paginiert ungefiltert, die Belegart-Einschraenkung (Gutschrift: nur
   * Geschaeftskontakte in Deutschland) passiert erst im Client. Eine Seite kann
   * deshalb nach dem Filtern leer oder zu kurz sein, obwohl der Server weitere
   * passende Kontakte haette. Ohne Optionen rendert die Auswahlliste keinen
   * Scroll-Container, das Nachladen per Scroll kaeme also nie in Gang. Deshalb
   * wird so lange die naechste Seite angefordert, bis eine volle Seite
   * auswaehlbarer Kontakte vorliegt oder der Server keine Seiten mehr hat.
   */
  readonly loadMoreUntilPageFilled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KontaktActions.setDisplayedIds, KontaktActions.addDisplayedIds),
      withLatestFrom(
        this.store.select(KontaktSelectors.selectableKunden),
        this.store.select(KontaktSelectors.hasMorePages),
      ),
      filter(([, selectable, hasMorePages]) => hasMorePages && selectable.length < KONTAKT_PAGE_SIZE),
      map(() => KontaktActions.triggerReadMoreKunden()),
    ),
  );

}
